/**
 * Shared Types
 */

export enum ComponentSize {
  XXSmall = 'xxsmall',
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export type ButtonType = 'button' | 'submit' | 'reset';

// Re-export for convenience
export type { ButtonType as default } from './index';

